module.exports = __webpack_public_path__ + "img/zspace.bde677c5.png";